// extracted by mini-css-extract-plugin
export var pageAdditionalInfos = "detailsPage-module--page-additional-infos--b4db1";
export var pageBody = "detailsPage-module--page-body--2d397";
export var pageFooter = "detailsPage-module--page-footer--4d582";
export var pageFooterBack = "detailsPage-module--page-footer-back--0c88b";
export var pageIntro = "detailsPage-module--page-intro--9b304";
export var pageIntroContainer = "detailsPage-module--page-intro-container--ad548";
export var pageIntroImg = "detailsPage-module--page-intro-img--b3d31";
export var pageIntroImgFull = "detailsPage-module--page-intro-img-full--0c4a6";
export var pageIntroTaxoContainer = "detailsPage-module--page-intro-taxo-container--db993";
export var pageIntroTitle = "detailsPage-module--page-intro-title--e347b";
export var pageTaxo = "detailsPage-module--page-taxo--b620d";